
<div class="legal-page" *ngIf="policy as p; else notFound">

  <!-- Hero -->
  <section class="legal-hero">
    <div class="container">
      <a routerLink="/" class="back-link">
        <i class="bi bi-arrow-left"></i> Back to Home
      </a>

      <div class="hero-content">
        <span class="legal-eyebrow">BUDGET BAZAAR</span>
        <h1>{{ p.title }}</h1>
        <p class="hero-description">
          Clear and transparent information about shopping with us.
        </p>
        <span class="effective-date">
          Effective Date: {{ p.effectiveDate }}
        </span>
      </div>
    </div>
  </section>

  <!-- Policy Navigation -->
  <section class="policy-navigation">
    <div class="container">
      <div class="policy-links">
        <a routerLink="/terms-and-conditions"
           routerLinkActive="active"
           [class.active]="policyKey === 'terms'">
          Terms &amp; Conditions
        </a>

        <a routerLink="/privacy-policy"
           [class.active]="policyKey === 'privacy'">
          Privacy Policy
        </a>

        <a routerLink="/refund-policy"
           [class.active]="policyKey === 'refund'">
          Refund Policy
        </a>

        <a routerLink="/cancellation-policy"
           [class.active]="policyKey === 'cancellation'">
          Cancellation Policy
        </a>
      </div>
    </div>
  </section>

  <!-- Main Content -->
  <main class="container policy-container">
    <div class="row g-4">

      <div class="col-12 col-lg-8">
        <article class="policy-card">

          <div class="policy-intro">
            <div class="intro-icon">
              <i class="bi bi-shield-check"></i>
            </div>
            <p>{{ p.intro }}</p>
          </div>

          <section
            class="policy-section"
            *ngFor="let section of p.sections">

            <h2>{{ section.heading }}</h2>

            <p *ngFor="let paragraph of section.paragraphs">
              {{ paragraph }}
            </p>

            <ul *ngIf="section.bullets?.length">
              <li *ngFor="let bullet of section.bullets">
                {{ bullet }}
              </li>
            </ul>
          </section>

          <!-- Contact section -->
          <section class="policy-section contact-policy">
            <h2>
              {{ policyKey === 'privacy'
                ? '12. Contact Us'
                : policyKey === 'terms'
                  ? '14. Contact Us'
                  : policyKey === 'refund'
                    ? '11. Contact Us'
                    : '9. Contact Us' }}
            </h2>

            <p>
              For questions, requests, complaints or assistance regarding
              this policy, please contact Budget Bazaar.
            </p>

            <div class="contact-details">
              <div class="contact-row">
                <i class="bi bi-building"></i>
                <div>
                  <strong>Business Name</strong>
                  <span>{{ contact.business }}</span>
                </div>
              </div>

              <div class="contact-row">
                <i class="bi bi-envelope"></i>
                <div>
                  <strong>Email</strong>
                  <a [href]="'mailto:' + contact.email">
                    {{ contact.email }}
                  </a>
                </div>
              </div>

              <div class="contact-row">
                <i class="bi bi-telephone"></i>
                <div>
                  <strong>Phone</strong>
                  <a [href]="'tel:' + contact.phoneLink">
                    {{ contact.phone }}
                  </a>
                </div>
              </div>

              <div class="contact-row">
                <i class="bi bi-geo-alt"></i>
                <div>
                  <strong>Business Address</strong>
                  <span>{{ contact.address }}</span>
                </div>
              </div>

              <div class="contact-row">
                <i class="bi bi-globe"></i>
                <div>
                  <strong>Website</strong>
                  <a [href]="contact.website" target="_blank"
                     rel="noopener noreferrer">
                    budgetbazaar.store
                  </a>
                </div>
              </div>
            </div>
          </section>

        </article>
      </div>

      <!-- Sidebar -->
      <div class="col-12 col-lg-4">
        <aside class="support-card">
          <div class="support-icon">
            <i class="bi bi-headset"></i>
          </div>

          <h3>Need Help?</h3>
          <p>
            Have questions about our policies or your order?
            Our support team is here to help.
          </p>

          <a class="support-button"
             [href]="'mailto:' + contact.email">
            <i class="bi bi-envelope me-2"></i>
            Email Support
          </a>

          <a class="support-phone"
             [href]="'tel:' + contact.phoneLink">
            <i class="bi bi-telephone me-2"></i>
            {{ contact.phone }}
          </a>

          <hr>

          <h4>Other Policies</h4>

          <a routerLink="/terms-and-conditions"
             *ngIf="policyKey !== 'terms'">
            <i class="bi bi-file-text"></i> Terms &amp; Conditions
            <i class="bi bi-chevron-right"></i>
          </a>

          <a routerLink="/privacy-policy"
             *ngIf="policyKey !== 'privacy'">
            <i class="bi bi-shield-lock"></i> Privacy Policy
            <i class="bi bi-chevron-right"></i>
          </a>

          <a routerLink="/refund-policy"
             *ngIf="policyKey !== 'refund'">
            <i class="bi bi-arrow-counterclockwise"></i> Refund Policy
            <i class="bi bi-chevron-right"></i>
          </a>

          <a routerLink="/cancellation-policy"
             *ngIf="policyKey !== 'cancellation'">
            <i class="bi bi-x-circle"></i> Cancellation Policy
            <i class="bi bi-chevron-right"></i>
          </a>
        </aside>
      </div>

    </div>
  </main>
</div>

<ng-template #notFound>
  <div class="container text-center py-5">
    <h2>Policy Not Found</h2>
    <p>The requested policy could not be found.</p>
    <a routerLink="/" class="btn btn-dark">Back to Home</a>
  </div>
</ng-template>
